import { getCurrentInstance } from 'vue';

const useStore = () => {
  const vm = getCurrentInstance().proxy;

  return vm.$store;
};

export { useStore };
